import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Stack, Tab, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import Roles from "../../../../common/enums/Roles";
import UserReturnPos from "./sub-component/UserReturnPos";
import ManagerReturnPos from "./sub-component/ManagerReturnPos";

const UserReturnAcknowledgementDesktop = () => {
  const TAB_STORAGE_KEY = "user_return_acknowledgement_tab";

  const { userRole, decodeToken } = CustomerDatabaseStore();
  const [value, setValue] = useState<string>("user_return_acknowledgement");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    decodeToken();
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

useEffect(() => {
  const storedTab = localStorage.getItem(TAB_STORAGE_KEY);

  if (!userRole?.role) return;

  if (
    userRole.role === Roles.HEADQUATER_MANAGER &&
    storedTab === "manager_return_acknowledgement"
  ) {
    setValue("user_return_acknowledgement");
    localStorage.setItem(TAB_STORAGE_KEY, "user_return_acknowledgement");
  } else {
    setValue(storedTab || "user_return_acknowledgement");
  }
}, [userRole]);


  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    localStorage.setItem(TAB_STORAGE_KEY, newValue);
  };

  return (
    <>
      <Stack sx={{ position: "relative" }}>
        <TabContext value={value}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            flexDirection={{ xs: "column", md: "row" }}
            gap={2}
            mb={2}
            pl={2}
            pt={1}
          >
            <Box sx={{ flex: "0 0 auto", minWidth: "200px" }}>
              <Typography variant="h5" fontWeight={550}>
                User Return Acknowledgement
              </Typography>
            </Box>
          </Box>
          <TabList onChange={handleChange} sx={{ ml: 2 }}>
            <Tab
              label="User Return Acknowledgement"
              value="user_return_acknowledgement"
            />

            {userRole?.role !== Roles.HEADQUATER_MANAGER && (
              <Tab
                label="Manager Return Acknowledgement"
                value="manager_return_acknowledgement"
              />
            )}
          </TabList>
          <TabPanel sx={{ p: 0 }} value="user_return_acknowledgement">
            <UserReturnPos />
          </TabPanel>
          {userRole?.role !== Roles.HEADQUATER_MANAGER && (
            <TabPanel sx={{ p: 0 }} value="manager_return_acknowledgement">
              <ManagerReturnPos />
            </TabPanel>
          )}
        </TabContext>
      </Stack>
    </>
  );
};

export default UserReturnAcknowledgementDesktop;
